import React from "react";
import "@/App.css";
import "@/print.css";
import "@/lib/axios"; // installs the axios cookie/401 interceptor
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LibraryPage from "@/pages/LibraryPage";
import AnimalPage from "@/pages/AnimalPage";
import BreedingsPage from "@/pages/BreedingsPage";
import ComparePage from "@/pages/ComparePage";
import SharePage from "@/pages/SharePage";
import PrintPage from "@/pages/PrintPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import TrialExpiredPage from "@/pages/TrialExpiredPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import WelcomePage from "@/pages/WelcomePage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/trial-expired" element={<ProtectedRoute><TrialExpiredPage /></ProtectedRoute>} />

            {/* Authenticated app */}
            <Route path="/" element={<ProtectedRoute redirectTo="/welcome"><LibraryPage /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="/animals/:id" element={<ProtectedRoute><AnimalPage /></ProtectedRoute>} />
            <Route path="/breedings" element={<ProtectedRoute><BreedingsPage /></ProtectedRoute>} />
            <Route path="/compare" element={<ProtectedRoute><ComparePage /></ProtectedRoute>} />
            <Route path="/print/:id" element={<ProtectedRoute><PrintPage /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
